export default __webpack_public_path__ + "static/finalizacion-3194a1025d95fb22d8a07564abf55516.jpg";